import React from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import Dropdown from 'react-dropdown';

export const ModalModificarServicio = (props) => {
	const {
		UseModalModifyServicio,
		setUseModalModifyServicio,
		modifyServicio,
		returnCategoriasOnlyName,
		modificacionServicio,
		setModificacionServicio,
	} = props;

	return (
		<>
			<Modal
				centered={true}
				isOpen={UseModalModifyServicio}
				toggle={() => setUseModalModifyServicio(false)}
			>
				<ModalHeader>
					<b>Modificar nombre de la categoria</b>
				</ModalHeader>
				<ModalBody>
					<div>
						<div className='datoFormularioUsuario'>
							<div className='labelDatoFormUsu'>
								Seleccione la categoria del servicio
							</div>
							<div style={{width: '231px'}}>
								<Dropdown
									className='miDropDown'
									options={returnCategoriasOnlyName()}
									onChange={(e) => {
										setModificacionServicio({
											...modificacionServicio,
											categoria: e.value,
										});
									}}
									value={modificacionServicio.categoria}
									placeholder='Select an option'
								/>
							</div>
						</div>
						<div className='datoFormularioUsuario'>
							<div className='labelDatoFormUsu'>
								Seleccione el nombre del servicio{' '}
							</div>
							<div>
								<input
									style={{width: '231px'}}
									type='text'
									className='inputTextUsuario'
									placeholder={'Nombre de la Categoria'}
									value={modificacionServicio.servicio}
									onChange={(e) => {
										setModificacionServicio({
											...modificacionServicio,
											servicio: e.target.value,
										});
									}}
								/>
							</div>
						</div>
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='buttons-modal-categoria'>
						<div
							className='button'
							onClick={() => setUseModalModifyServicio(false)}
						>
							<b>Cancelar</b>
						</div>
						<div
							className='button'
							onClick={() => modifyServicio()}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>
		</>
	);
};
